<div class="admin_panel">
  <!-- <mat-horizontal-stepper  #stepper>
        <mat-step label="Cooler"></mat-step>
        <mat-step label="Product"></mat-step>
        <mat-step label="Plano Guidelines"></mat-step>
    </mat-horizontal-stepper> -->
  <!-- <table mat-table #mytable [dataSource]="dataSource">

    </table> -->
  <div class="gap"></div>
  <div class="back">
    <em
      (click)="moveBack()"
      class="bi bi-arrow-left"
      style="margin-right: 5px; font-weight: 600"
    ></em>
    Admin Panel
  </div>
  <div class="header">
    <div
      (click)="SetSelectedSection('cooler')"
      class="cooler"
      [ngClass]="{ selected: selectedSection == 'cooler' }"
    >
      Cooler
    </div>
    <div class="borders"></div>
    <div
      (click)="SetSelectedSection('product')"
      class="product"
      [ngClass]="{ selected: selectedSection == 'product' }"
    >
      Products
    </div>
    <div class="borders"></div>
    <div
      (click)="SetSelectedSection('guidelines')"
      class="guidelines"
      [ngClass]="{ selected: selectedSection == 'guidelines' }"
    >
      Plano Guidelines
    </div>
  </div>
  <div class="body">
    <div *ngIf="selectedSection === 'cooler'">
      <app-admin-cooler-panel></app-admin-cooler-panel>
    </div>
    <div *ngIf="selectedSection === 'product'">
      <app-admin-product-panel></app-admin-product-panel>
    </div>
    <div *ngIf="selectedSection === 'guidelines'">
      <app-admin-guidelines-panel></app-admin-guidelines-panel>
    </div>
  </div>
  <div class="gap"></div>
</div>
